import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

const GiftCardsRedeemPage = () => {
  const router = useRouter();
  useEffect(() => {
    router.push('/');
  }, []);
  return (
    <div></div>
  );
};

export default GiftCardsRedeemPage;
